import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=fea09dca&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fea09dca')) {
      api.createRecord('fea09dca', component.options)
    } else {
      api.reload('fea09dca', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=fea09dca&", function () {
      api.rerender('fea09dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22IB2mcVOfTtg/JS/videoIframe.vue"
export default component.exports